import { render } from "./EconomicClassificationForm.vue?vue&type=template&id=65f452cc"
import script from "./EconomicClassificationForm.vue?vue&type=script&lang=js"
export * from "./EconomicClassificationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__